import { Box, Flex } from '@chakra-ui/react';
import { ArrowBack } from '@material-ui/icons';
import { getApplicableL2MyDataModules } from 'Deer/components/navigation/secondary/ModuleSection';
import { L3_PATHS } from 'Deer/constants/routes';
import { DeerBreadcrumbs } from 'Deer/intent/components/Layout/Layout';
import { useSelectIsL2Visible } from 'Deer/slice/DeerNav.slice';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { isNetchexLogin } from 'constants/netChexConstants';
import { routes } from 'constants/routes';

import { Button } from 'uiToolkitV1/Button';
import { TextHeader2 } from 'uiToolkitV1/Typography';

import { EngagementSurveyResultsTable } from './components/EngagementSurveyResultsTable';
import { useGetEngagementSurveyResults } from './hooks/dataHooks';

const SurveyResultDeerPage = () => {
  const history = useHistory();
  const { moduleName } = useOrganisationSettings();

  const applicableL2MyDataModules = getApplicableL2MyDataModules(moduleName) ?? [];

  const match = useRouteMatch({
    path: checkNewNavEnabled() ? L3_PATHS['my-data'].engagement.submittedSurvey : routes.engagement.pastSurvey,
    exact: true,
  });
  const { surveyId } = match.params as { surveyId: string };

  const { data, isLoading, isError } = useGetEngagementSurveyResults(surveyId);

  const { name } = data ?? {};

  const isL2NavVisible = useSelectIsL2Visible();

  const backClickHandler = () => {
    history.goBack();
  };
  return (
    <Box>
      <Flex
        ml={!isL2NavVisible ? '24px' : 0}
        padding="9px 0px"
        w="100%"
        justifyContent="space-between"
        alignItems="center"
      >
        <Flex alignItems="center">
          <Button
            mr="8px"
            StartIcon={ArrowBack}
            variant="tertiary"
            onClick={backClickHandler}
            data-testid="header-go-back"
          />
          <Flex flexDir="column">
            {!isNetchexLogin && (
              <DeerBreadcrumbs
                breadcrumbs={{
                  items: [
                    {
                      label: 'Me',
                      to: applicableL2MyDataModules[0]?.value,
                    },
                    {
                      label: 'Engagement',
                      to: `${L3_PATHS['my-data'].engagement.mySurveys}?surveyType=SUBMITTED_SURVEYS`,
                    },
                  ],
                  page: {
                    label: name,
                    to: '',
                  },
                }}
              />
            )}
            <TextHeader2 bold>Survey Result</TextHeader2>
          </Flex>
        </Flex>
      </Flex>
      {/* <SurveyResultTable surveyId={surveyId} isError={isError} isLoading={isLoading} resultData={data} /> */}
      <EngagementSurveyResultsTable isError={isError} isLoading={isLoading} resultData={data} />
    </Box>
  );
};

export { SurveyResultDeerPage };
